import axios from 'axios';

// Whether a rejected request was cancelled rather than failed, so callers can
// stay silent instead of surfacing an error the user did not cause. Aborts
// arrive under three spellings depending on how the request was torn down:
// the controller's own flag, axios' cancellation marker, and the DOM
// AbortError that fetch-backed adapters raise.
const cancelledRequest = (error, controller) => (
  controller.signal.aborted || axios.isCancel(error) || error?.name === 'CanceledError'
);

export default cancelledRequest;
